import { ServiceStatus } from '@rematter/frontend-lib-api-client';

import { SERVICE_FRAGMENT } from '../@shared-fragments/serviceFragment';
import { mapService } from '../@shared-mappers/mapService';
import { useLoadBoardServicesQuery } from '../queries/useLoadBoardServicesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useServiceTransitionMutation = createMutationHook(
  'transportation.serviceTransition',
  (params: { id: string; status: ServiceStatus; notes?: string }) => ({
    transportationServiceTransition: {
      __args: {
        input: {
          id: params.id,
          status: params.status,
          notes: params.notes,
        },
      },
      ...SERVICE_FRAGMENT,
    },
  }),
  {
    select: ({ transportationServiceTransition: service }) =>
      mapService(service),
    invalidateQueries: [useLoadBoardServicesQuery],
  },
);
